<template>
  <div>
    <el-checkbox-group @change="()=>changeFunction()" v-model="checkboxgroupValue" :ref="checkboxgroupRef" :style="`
    ${checkboxgroupData.questioncolumn ? 'flex-direction:column; display:flex;' :''}
    ${checkboxgroupData.indent > 0 ? 'margin-left: ' +  checkboxgroupData.indent + 'px;' + 'margin-bottom: 10px;' + 'margin-top: 10px':''} 
    `">
      <!-- <span style="font-size: 32px;">ABC</span> -->
      <img v-if="checkboxgroupData.tiles" class="tileimageclass" :src="automation_level"/>
      <p v-if="checkboxgroupData.tiles" style="display: flex; flex-direction: column; align-items: center; width: 100%; font-size: 20px; margin-bottom: 20px">Figure 1: Level of Automation</p>
      <div v-for="(suboption, index) in checkboxgroupData.optionSetOptionList" :key="index">
        <template v-if="suboption.optionHoverLabel">
          <el-tooltip v-if="siblingBehavior(suboption)" :content="suboption.optionHoverLabel" placement="right-start" effect="light">
            <el-checkbox :label="suboption.optionLabel" :disabled="suboption.optionAutoChecked || locked"></el-checkbox>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </template>
        <template v-else>
          <el-checkbox v-if="siblingBehavior(suboption)" :label="suboption.optionLabel" :disabled="suboption.optionAutoChecked || locked"></el-checkbox>
        </template>
        <!-- <span style="font-size: 32px;">{{suboption.optionLabel}}</span> -->
        <template v-if="suboption.optionSubOptionSetList">
          <div v-for="(suboptionset, index2) in suboption.optionSubOptionSetList" :key="index2">
            <!-- <span style="font-size: 32px;">{{checkboxgroupValue.includes(suboption.optionLabel)}}</span> -->
            <template v-if="checkboxgroupValue.includes(suboption.optionLabel)">
              <stu-radio-group :changeFunction="changeFunction" v-if="suboptionset.optionSetType === 'radio'" :formData="formData" :parentId="`${parentId}_${checkboxgroupData.optionSetId}_${suboption.optionId}`" :radiogroupData="suboptionset" :radiogroupRef="`${checkboxgroupRef}_suboptionset${index}`" :locked="locked"></stu-radio-group>
              <stu-checkbox-group :changeFunction="changeFunction" v-else-if="suboptionset.optionSetType === 'checkbox'" :formData="formData" :parentId="`${parentId}_${checkboxgroupData.optionSetId}_${suboption.optionId}`" :checkboxgroupData="suboptionset" :checkboxgroupRef="`${checkboxgroupRef}_suboptionset${index}`" :locked="locked"></stu-checkbox-group>
            </template>
          </div>
        </template>
        <template v-if="suboption.optionSubQuestionList">
          <div v-for="(subquestion, index4) in suboption.optionSubQuestionList" :key="index4">
            <!-- <span style="display: inline; line-height: 32px; font-size: 32px;">{{ `${parentId}_${checkboxgroupData.optionSetId}_${suboption.optionId}` }}</span> -->
            <stu-question :changeFunction="changeFunction" v-if="checkboxgroupValue.includes(suboption.optionLabel)" :formData="formData" :parentId="`${parentId}_${checkboxgroupData.optionSetId}_${suboption.optionId}`" :questionData="subquestion" :questionRef="`${checkboxgroupRef}_subquestion${index4}`" :locked="locked"></stu-question>
          </div>
        </template>
      </div>
    </el-checkbox-group>
    <div v-for="(subquestion, index5) in checkboxgroupData.optionSetSubQuestionList" :key="index5">
      <!-- <span style="display: inline; line-height: 32px; font-size: 32px;">{{checkboxgroupValue}}</span> -->
      <template v-if="checkboxgroupValue.length > 0 && questionSiblingBehavior(subquestion)">
        <stu-question :changeFunction="changeFunction" :formData="formData" :parentId="`${parentId}_${checkboxgroupData.optionSetId}`" :questionData="subquestion" :questionRef="`${checkboxgroupRef}_subquestion${index5}`" :locked="locked"></stu-question>
      </template>
    </div>
  </div>
</template>
<script>
import automation_level from '@/assets/automation_level3.png'

export default {
  name: "stu-checkbox-group",
  data() {
    return {
      checkboxgroupValue: [],
      btnloading: false,
      automation_level,
    }
  },
  props: {
    checkboxgroupData: {
      type: Object
    },
    checkboxgroupRef: {
      type: String
    },
    formData: {
      type: Object
    },
    changeFunction: {
      type: Function
    },
    parentId: {
      type: String
    },
    locked: {
      type: Boolean
    }
  },
  methods: {
    siblingBehavior(suboption) {
      if (suboption.optionSiblingSpecialBehavior === 'revealOnly' && suboption.optionSiblingList && suboption.optionSiblingList.length > 0) {
        // console.log(`this.formData[${this.parentId}_${this.checkboxgroupData.optionSetId}]`)
        let visible = true
        for (var sibling of suboption.optionSiblingList) {
          const optionSiblingOptionId = sibling.optionSiblingOptionId
          const optionSiblingOptionValue = sibling.optionSiblingOptionValue
          const siblingKey = `${this.parentId}_${this.checkboxgroupData.optionSetId}_${optionSiblingOptionId}`
          if (this.formData[siblingKey] !== optionSiblingOptionValue) {
            visible = false
            break
          }
        }
        return visible
        // return !this.checkboxgroupValue.includes(suboption.optionSibling)
      }
      return true
    },
    questionSiblingBehavior(question) {
      if (question.questionSiblingSpecialBehavior === 'revealOnly' && question.questionSiblingList && question.questionSiblingList.length > 0) {
        let visible = true
        // console.log(this.formData)
        for (var sibling of question.questionSiblingList) {
          const questionSiblingOptionId = sibling.questionSiblingOptionId
          const questionSiblingOptionValue = sibling.questionSiblingOptionValue
          const siblingKey = `${this.parentId}_${this.checkboxgroupData.optionSetId}_${questionSiblingOptionId}`
          // console.log(`${siblingKey}`, this.formData[siblingKey])
          if (this.formData[siblingKey] !== questionSiblingOptionValue) {
            visible = false
            break
          }
        }
        return visible
      }
      return true
    }
  },
  watch: {
    checkboxgroupValue() {
      this.formData[`${this.parentId}_${this.checkboxgroupData.optionSetId}`] = this.checkboxgroupValue
      for (var option of this.checkboxgroupData.optionSetOptionList) {
        const optionId = option.optionId
        const checked = this.checkboxgroupValue.includes(option.optionLabel)
        this.formData[`${this.parentId}_${this.checkboxgroupData.optionSetId}_${optionId}`] = checked
      }
    }
  },
  computed: {
    // suboptions() {
    //   // const suboptions = []
    //   if (this.checkboxgroupData) {
    //     // for (var i in this.checkboxgroupData.optionSetOptionList) {
    //     //   const optionSetOption = this.checkboxgroupData.optionSetOptionList[i]
    //     //   const optionSubOptionSetList = optionSetOption.optionSubOptionSetList
    //     //   if (optionSubOptionSetList.length > 0) {
    //     //     suboptions.push(optionSetOption)
    //     //   }
    //     // }
    //     // return suboptions
    //     return this.checkboxgroupData.optionSetOptionList ? this.checkboxgroupData.optionSetOptionList : []
    //   }
    //   return []
    // }
  },
  mounted() {
    // console.log(`${this.parentId}_${this.checkboxgroupData.optionSetId}`)
    // console.log(this.formData[`${this.parentId}_${this.checkboxgroupData.optionSetId}`])
    this.checkboxgroupValue = this.formData[`${this.parentId}_${this.checkboxgroupData.optionSetId}`]
  },
  beforeDestroy() {
  }
};
</script>


// WEBPACK FOOTER //
// src/views/msma/components/StuCheckboxGroup.vue